/* eslint-disable react/jsx-pascal-case */
import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import {
    mainSlice,
    selectMainState,
    useDispatch,
} from "../../../stateManagement/redux";
import { DepartmentNameEnum } from "../../../stateManagement/redux/slices/shared/interfaces";
import "./style.scss";

interface Props {
    icon: any;
    onClick?: () => void;
    iconHeight?: number;
    iconWidth?: number;
    notification?: boolean;
    activeDepartmentId: DepartmentNameEnum;
}

function Button_Projects(props: Props) {
    const mainState = useSelector(selectMainState);

    return (
        <div
            className={`${
                mainState?.activeDepartmentId === props.activeDepartmentId
                    ? "button_projects_active"
                    : "button_projects"
            }`}
            onClick={props.onClick}
        >
            <img src={props.icon} alt="logo" height={40} width={40} />
            {props.notification && <div className="button_projects__alert" />}
        </div>
    );
}

export const RightMenuProjects = (props: { children?: React.ReactNode }) => {
    const dispatch = useDispatch();

    const onClick = (value: DepartmentNameEnum) => {
        dispatch(mainSlice.actions.setProjectOnClick(value));
    };

    return (
        <Box className="right_menu_projects">
            <Button_Projects
                icon="/assets/icons/well_whisper.svg"
                iconHeight={25}
                iconWidth={25}
                onClick={() => onClick(DepartmentNameEnum.wellWhisper)}
                activeDepartmentId={DepartmentNameEnum.wellWhisper}
            />
            {/* <Button_Projects
                icon="/assets/icons/rigs.svg"
                iconHeight={25}
                iconWidth={25}
                onClick={() => onClick(DepartmentNameEnum.rig)}
                activeDepartmentId={DepartmentNameEnum.rig}
            />
            <Button_Projects
                icon="/assets/icons/tanks.svg"
                iconHeight={25}
                iconWidth={25}
                onClick={() => onClick(DepartmentNameEnum.tanks)}
                activeDepartmentId={DepartmentNameEnum.tanks}
            />
            <Button_Projects
                icon="/assets/icons/gasMeasure.svg"
                iconHeight={25}
                iconWidth={25}
                onClick={() => onClick(DepartmentNameEnum.gasMeasure)}
                activeDepartmentId={DepartmentNameEnum.gasMeasure}
            /> */}
        </Box>
    );
};
